/**
 * Query key factory for Catalog module
 * Provides centralized query key management for React Query
 */

export const catalogKeys = {
  all: ['catalog'] as const,

  // Product keys
  product: (sku: string) => [...catalogKeys.all, 'product', sku] as const,
  productAttributes: (sku: string) => [...catalogKeys.product(sku), 'attributes'] as const,

  // Related products keys
  autoRelated: (sku: string) => [...catalogKeys.product(sku), 'autoRelated'] as const,
  autoRelatedSkus: (sku: string) => [...catalogKeys.product(sku), 'autoRelatedSkus'] as const,
}
